import { useMemo } from "react";
import { ChevronRight, Scale } from "lucide-react";
import type { DashboardData } from "../../types";
import { reconciliationMonthLabel, reconciliationState } from "../../lib/reconciliation";

export interface ReconciliationCardProps {
  data: DashboardData;
  month: string;
  onOpen: () => void;
}

export default function ReconciliationCard({
  data,
  month,
  onOpen,
}: ReconciliationCardProps) {
  const state = useMemo(() => reconciliationState(data, month), [data, month]);
  const label = reconciliationMonthLabel(month);

  if (state.complete) return null;
  const resolved = state.items.filter((item) => item.valid).length;

  return (
    <button
      type="button"
      className="reconciliation-card overview-alert"
      onClick={onOpen}
    >
      <span className="reconciliation-card-icon">
        <Scale size={20} />
      </span>
      <span>
        <strong>{label} needs review</strong>
        <small>
          {resolved} of {state.items.length} account balances confirmed
        </small>
      </span>
      <ChevronRight size={18} />
    </button>
  );
}
